<template>
<div style="background:#000;width:100%;">
    <div class="evdenceActivity">
        <div class="first-module">
            <span class="span-one" @click="inviteFriend()">邀请他人注册</span>
            <span class="span-two" @click="receiveGift()">领取注册礼包</span>
        </div>
        <div class="second-module"></div>
        <div class="third-module"></div>
        <div class="fourth-module"></div>
        <div class="fifth-module"></div>
        <ul class="fixed-module">
            <li class="li-one">
                <p class="p12">取证宝APP</p>
                <img src="./img/code.png" class="codeimg" alt='版权登记'/>
                <p class="p12" style="font-weight:bold;">扫码下载</p>
            </li>
            <li class="li-two">
                <p class="p12" style=" margin:5px 0 10px;">取证宝网页版</p>
                <a v-if="testEnv"  href="https://tsmars.bqj.cn/#/login?type=bqjquzheng" target="_blank" class="li-a">点此去取证</a>
                <a v-if="preEnv"  href="https://tsmars.bqj.cn/#/login?type=bqjquzheng" target="_blank" class="li-a">点此去取证</a>
                <a v-if="proEnv"  href="https://svip.bqj.cn/#/login?type=bqjquzheng" target="_blank" class="li-a">点此去取证</a>
            </li>
        </ul>       
    </div>

    <!-- 老用户 -->
    <div class="generalframezz" v-if="modal1">
        <div class="generalcontent" style="width:285px;height:277px;">
            <img src="./img/no.png" class="imgStyle" style="margin:10px 0 4px;" alt='版权登记'/>
            <p class="p16-modal">很遗憾！</p>
            <p class="p14-modal">您是老用户无法领取注册礼包</p>
            <p class="p14-modal" style="margin:8px 0 31px">邀请其他用户注册成功，可获得邀请礼包</p>
            <button class="btn-modal" @click="showInvite">邀请他人注册</button>
        </div>
    </div>

    <!-- 领取完成！ -->
    <div class="generalframezz" v-if="modal2">
        <div class="generalcontent" style="width:460px;height:499px;">
            <img src="./img/close.png" class="closeImg" @click="closeModal2" alt='版权登记'/>
            <img src="./img/yes.png" class="imgStyle" style="margin:0 186px" alt='版权登记'/>
            <p class="p16-modal">领取完成！</p>
            <p class="p14-modal">快去登录取证宝APP看看吧</p>
            <p style="position:relative;margin:25px 0;">
                <img src="./img/big.png" class="bigImg" alt='版权登记'/>
                <img src="./img/small.png" class="smallImg" alt='版权登记'/>
                <img src="./img/code.png" class="positionimg" alt='版权登记'/>
            </p>
            <p>
                <button v-if="testEnv" class="btn-modal-entry"><a href="https://tsmars.bqj.cn/" target="_blank" style="color:#333">进入取证宝网页版</a></button>
                <button v-if="preEnv" class="btn-modal-entry"><a href="https://tsmars.bqj.cn/" target="_blank" style="color:#333">进入取证宝网页版</a></button>
                <button v-if="proEnv" class="btn-modal-entry"><a href="https://svip.bqj.cn/" target="_blank" style="color:#333">进入取证宝网页版</a></button>
                <button class="btn-modal-entry" style="background:rgba(248,248,248,1);margin-left:20px;">扫码下载APP</button>
            </p>           
        </div>
    </div>

    <!-- 邀请链接地址 -->
    <div class="generalframezz" v-if="modal3">
        <div class="generalcontent" style="width:534px;height:277px;">
            <img src="./img/close.png" class="closeImg" @click="closeModal" alt='版权登记'/>
            <img src="./img/link.png" class="imgStyle" alt='版权登记'/>
            <p class="p16-modal">邀请链接地址(请在手机上查看)</p>
            <p class="p14-modal" style="margin-bottom:39px;">{{inviteUrl}}</p>
            <button class="btn-modal"  
                v-clipboard:copy="inviteUrl" 
                v-clipboard:success="onCopy" 
                v-clipboard:error="onError">点击复制
            </button>
        </div>
    </div>

</div>
</template>

<script>
    import Cookies from "js-cookie";
    import $ from 'jquery';
    import {bqjUrl, svipUrl} from "../../../../../config/config";
    export default {
        name:'evdenceActivtiy',
        data(){
            return{
               modal1:false,
               modal2:false,
               modal3:false,
               inviteUrl:"",
               invitationQr:"",
               testEnv:false,
               proEnv:false,
                preEnv:false
            }
        },
        methods:{
            closeModal(){
                this.modal3=false
            },
            closeModal2(){
                this.modal2=false
            },
            showInvite(){
                this.modal1=false
                this.inviteFriend()
            },
            //邀请他人
            inviteFriend(){
                burialPoint('website','shareActivity','10001');
                let _this = this;
                let userInfo = Cookies.get("userInfo")?JSON.parse(Cookies.get("userInfo")):'';
                if(userInfo.length == 0){
                    _this.$store.state.app.showLoginOrRegistter = true
                    return false;
                }            
                $.ajax({
                    url: _this.API_ROOT_MARS + 'front/evidence/activity/getEvidenceActivityUrl',
                    type: "GET",
                    xhrFields: {
                        withCredentials: true
                    },                   
                    success:function (res) {
                        if(res.code=='200'){                          
                            _this.inviteUrl = res.evidenceActivityUrl  
                            _this.modal3=true                          
                        }else{
                            toast(res.message)
                        }
                    },
                    error: function () {
                        toast('活动太火爆，请刷新后重试~');
                    }
                })

           },
            //领取礼包
            receiveGift(){
                burialPoint('website','receiveActivity','10002');
                let _this = this;                 
                if(window.location.search){
                    let code = window.location.href
                    let n1 = code.length;
                    let n2 = code.indexOf("=");//取得=号的位置
                    _this.invitationQr = code.substr(n2 + 1, n1 - n2);//从=号后面的内容
                }else{
                    _this.invitationQr= "";
                }
                $.ajax({
                    url: _this.API_ROOT_MARS + 'front/evidence/activity/getEvidenceActivityGift',
                    type: "POST",
                    xhrFields: {
                        withCredentials: true
                    },
                    data:{invitationQr:_this.invitationQr},                    
                    success:function (res) {
                        if(res.code=='202'){
                            _this.modal1=true
                        }else if(res.code=='200'){
                            _this.modal2=true
                        }else if(res.code=='203'){
                            toast("您已经领取过注册礼包，不能重复领取")
                        }else{
                            toast(res.message)
                        }
                    },
                    error: function () {
                        toast('活动太火爆，请刷新后重试~');
                    }
                })

            },
            //复制
            onCopy(e) {
                toast("复制成功");
            },
            onError(e) {
                toast("复制失败");
            },
            initEnv(){


                switch (process.env.NODE_ENV) {
                    case 'pre':
                        this.preEnv=true
                        this.testEnv=false
                        this.proEnv=false
                        break
                    case 'test':
                        this.preEnv=false
                        this.testEnv=true
                        this.proEnv=false
                        break
                    case 'production':
                        this.preEnv=false
                        this.testEnv=false
                        this.proEnv=true
                        break
                }

            }

        },
        mounted() {
            this.initEnv();

        }
    }
</script>

<style scoped lang="less">
.evdenceActivity{
    width: 1200px;
    height: 2067px;
    background: #000;
    margin:0 auto;
    position: relative;
    div{
        width: 1200px;        
    }
    .second-module,
    .third-module,
    .fourth-module{
        margin-bottom: 30px;
    }
    .first-module{        
        height: 400px;
        background: url(./img/1.png) no-repeat;
        overflow: hidden;
        background-size: cover;
        .span-one{
            display: inline-block;
            width:148px;
            height:40px;
            line-height: 40px;
            text-align: center;
            background:rgba(255,216,0,1);
            box-shadow:0px 1px 14px 0px rgba(0,0,0,0.04);
            border-radius:20px;
            font-size:14px;
            font-weight:bold;
            color:rgba(51,51,51,1);
            cursor: pointer;
            margin:324px 29px 0 84px;
        }
        .span-two{
            display: inline-block;
            width:148px;
            height:40px;
            line-height: 40px;
            text-align: center;
            background:linear-gradient(180deg,rgba(247,234,139,1) 0%,rgba(220,200,89,1) 100%);
            border-radius:20px;
            cursor: pointer;
            font-size:14px;
            font-weight:bold;
            color:rgba(51,51,51,1);
            margin-top: 324px;
        }
    }
    .second-module{
        height: 329px;
        background: url(./img/2.png) no-repeat; 
        background-size: cover;      
    }
    .third-module{
        height: 504px;
        background: url(./img/3.png) no-repeat;
        background-size: cover;
    }
    .fourth-module{
        height:260px;
        background: url(./img/4.png) no-repeat; 
        background-size: cover;
    }
    .fifth-module{
        height:451px;
        background: url(./img/5.png) no-repeat;
        background-size: contain;
    }
    .fixed-module{
        height: 223px;
        width:114px;
        position: fixed;
        bottom:85px;
        margin-left:1071px;
        overflow: hidden;
        .li-one{
            width:114px;
            height:128px;
            background:rgba(246,246,246,1);
            box-shadow:0px 2px 9px 0px rgba(0,0,0,0.5);
            border-radius:4px;
            margin-bottom: 15px;
            text-align: center;
        }
        .codeimg{
            width:74px;
            height: 74px;
            margin:5px 0 2px;
        }
        .li-two{
            width:114px;
            height:80px;
            background:rgba(246,246,246,1);
            box-shadow:0px 2px 9px 0px rgba(0,0,0,0.5);
            border-radius:4px;
            text-align: center;
            overflow: hidden;
            .li-a{
                display: inline-block;
                width:94px;
                height:33px;
                line-height: 33px;
                background:rgba(255,216,0,1);
                box-shadow:0px 1px 14px 0px rgba(0,0,0,0.04);
                border-radius:2px;
                font-size:12px;
                font-weight:bold;
                color:rgba(51,51,51,1);
                text-align: center;
            }
        }
        .p12{
            font-size:12px;
            font-weight:400;
            color:rgba(51,51,51,1);
            line-height:17px;
           
        }
    } 
}  
.generalframezz{
    background: rgba(0, 0, 0, 0.7);
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    text-align: center;
    margin: auto;
    z-index: 558;
    .generalcontent{
        background:#fff;
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        margin: auto;
        border-radius:8px;
        text-align: center;
        overflow: hidden;
        .imgStyle{
            width:87px;
            height: 92px;
            margin:0px 223px;
        }
        .p16-modal{
            font-size:16px;
            font-weight:bold;
            color:rgba(46,46,46,1);
            line-height:22px;
            margin-bottom: 10px;
        }
        .p14-modal{
            font-size:14px;
            font-weight:400;
            color:rgba(51,51,51,1);
            line-height:20px;
        }
        .btn-modal{
            width:149px;
            height:38px;
            line-height: 38px;
            background:rgba(255,216,0,1);
            box-shadow:0px 1px 14px 0px rgba(255,216,0,0.36);
            border:0;
            border-radius:100px;
            cursor: pointer;
            outline: none;
            font-size:14px;
            font-weight:400;
            color:rgba(51,51,51,1);
        }
        .bigImg{
            width:245px;
            height: 207px;
        }
        .smallImg{
            position: absolute;
            top:62px;
            width:69px;
            height: 146px;
            left: 299px;
        }
        .positionimg{
            width:42px;
            height: 42px;
            position: absolute;
            top:119px;
            left:312px;
        }
        .btn-modal-entry{
            width:124px;
            height:31px;
            line-height: 31px;
            border:0;
            background:rgba(255,216,0,1);
            border-radius:2px;
            outline: none;
            cursor: pointer;
            font-size:12px;
            font-weight:400;
            color:rgba(51,51,51,1);
        }
        .closeImg{
            width:18px;
            height: 18px;
            margin-top:10px;
            float: right;
            margin-right: 10px;
            cursor: pointer;
        }
    }
}
</style>